import React from 'react';
import PropTypes from 'prop-types';
import AppPropTypes from 'proptypes/AppPropTypes';

import { clearPaymentActionMessage } from 'logic/store/payments/actions';
import withAppStyles from 'components/withAppStyles/withAppStyles';
import withRouterConnect from 'components/withRouterConnect/withRouterConnect';

import ActionAlert from './ActionAlert';
import styles from './PaymentActionAlerts.styles';
import nativeStyles from './PaymentActionAlerts.native.styles';

export const PaymentActionAlerts = ({
  classes,
  clearNotAllowed,
  clearPaymentActionMessage,
  locale,
  paymentActionMessages,
  paymentsGrid
}) => {
  if (!paymentActionMessages) {
    return null;
  }
  // if paymentgrid then show alert only is not smb flag, if smb grid then show alerts only with smb flag
  return (
    <div>
      {paymentActionMessages.map(
        (paymentActionMessage) =>
          ((!paymentsGrid && paymentActionMessage.smb) ||
            (paymentsGrid && !paymentActionMessage.smb)) && (
            <ActionAlert
              paymentActionMessage={paymentActionMessage}
              classes={classes}
              key={paymentActionMessage.id}
              clearPaymentActionMessage={clearPaymentActionMessage}
              clearNotAllowed={clearNotAllowed}
              duplicateMsg={paymentActionMessage.duplicateMsg}
              duplicateDetails={paymentActionMessage.duplicateDetails}
              locale={locale}
            />
          )
      )}
    </div>
  );
};

PaymentActionAlerts.propTypes = {
  classes: AppPropTypes.jssClasses.isRequired,
  clearNotAllowed: PropTypes.func,
  clearPaymentActionMessage: PropTypes.func,
  locale: PropTypes.shape({}),
  paymentActionMessages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      title: PropTypes.string,
      details: PropTypes.oneOfType([
        PropTypes.arrayOf(
          PropTypes.arrayOf(
            PropTypes.shape({
              head: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
              value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
            })
          )
        ),
        PropTypes.arrayOf(
          PropTypes.shape({
            head: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
          })
        )
      ]),
      msg: PropTypes.string,
      titleExtra: PropTypes.func,
      success: PropTypes.bool,
      warning: PropTypes.shape({
        hasWarning: PropTypes.bool,
        warningCode: PropTypes.string,
        warningMessage: PropTypes.string
      })
    })
  ),
  paymentsGrid: PropTypes.bool
};

PaymentActionAlerts.defaultProps = {
  clearNotAllowed() {},
  clearPaymentActionMessage: null,
  locale: {},
  paymentActionMessages: null,
  paymentsGrid: false
};

/* istanbul ignore next */
const mapStateToProps = (state) => ({
  paymentActionMessages: state.payments.paymentActionMessages
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
  clearPaymentActionMessage: (id) => dispatch(clearPaymentActionMessage(id))
});

const Styled = withAppStyles({ web: styles, native: nativeStyles }, PaymentActionAlerts);

export const PaymentActionAlertsComponent = withRouterConnect(
  mapStateToProps,
  mapDispatchToProps
)(Styled);

export default PaymentActionAlertsComponent;
